import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * shadcn/ui Input, in the AeroVect palette.
 *
 * Spells out the chrome (`bg-white`, `border`, `m-0`) that preflight would
 * normally have reset — see tailwind.config.js.
 */
const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type, ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      "m-0 box-border w-full rounded-md border border-inputLine bg-white px-2.5 py-1.5 font-sans text-[13px] text-ink placeholder:text-slate focus:border-blue focus:outline-none focus:ring-[3px] focus:ring-blue/15",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";

export { Input };
